module.exports = __webpack_public_path__ + "img/flag_openrun_black.be10feb.svg";